const carousel = {
  Trynow: '立即体验',
  Enter: '进入产品',
  Comingsoon: '即将上线，敬请期待',
  Applicationsuccessful: '申请成功',
  Unsuccessful: '申请失败',
  slides1Title: '如何进行多数据源交叉分析',
  slides1DescHtml: '多维数据是为智库用户量身打造的多数据源交叉分析工具；支持用户灵活自由组合，无需SQL编程能力和开发人员支持，通过拖拉拽即可轻松自如地完成数据的提取和探查工作。',
  slides1ProductName: '多维数据',
  slides2Title: '整车全指标图片如何一站式查看',
  slides2DescHtml: '车型体验库是一款可进行整车全指标图片分析的产品，通过更全面、更细颗粒度的场景化车型图片，辅助用户进行整车产品分析。',
  slides2ProductName: '车型体验库',
  slides3Title: '整车在市场中智能水平如何',
  slides3DescHtml: '通过功能广度、功能深度、用户体验、用户洞察、OTA成长性这五个维度， 对整车的智能化程度进行综合性评价，助您更好的评判本竞品车型在智能化方面的综合竞争力。',
  slides4Title: '如何快速调整购车权益',
  slides4DescHtml: '通过长期稳定检测，建立完善的结构化权益数据库。方便行业了解车企购车权益营销内容。<br />助您进行各品牌、车型购车权益营销方面的对标分析，掌握行业营销发展趋势。',
}

const products = {
  productDesc1: '实时监控企业、市场的发展',
  productDesc2: '通过交叉分析，实现精细化的研究',
  productDesc3: '快速完成复杂的分析课题',
  productDesc4: '快速获取数据，并便捷的处理',
  Other: '其他',
}

const solutions = {
  solutionsDesc1: '支持高层战略决策的智能系统',
  solutionsDesc2: '场景化智能决策支持系统',
  solutionsDesc3: '汽车行业首家数据分析 BI 平台',
}

export default {
  ...carousel,
  ...products,
  ...solutions,
  headerLogoTitle: '智库决策支持系统',
  Homepage: '首页',
  products: '数据产品',
  productsTip: '为汽车厂家提供日常决策所需数据分析，实现高效管理和数据可视化',
  solutions: '场景化方案',
  solutionsTip: '从场景出发深入读懂用户决策所需，构建智能决策场景',
  detail: '详情',
  viewDetail: '查看详情',
  IndustryInsights: '行业洞察',
  IndustryInsightsTip: '专注于汽车领域的最新趋势，以专业视角收集和研究市场数据、商业政策、新能源前沿技术、焦点车企与热门车型动态',
  headerUser: '个人中心',
  Login: '登录',
  LoginSlogen1: '全球领先的',
  LoginSlogen2: '汽车产业数字化应用平台',
  loginTypePassword: '密码登录',
  vertifycodeLogin: '验证码登录',
  qrcodeLogin: '扫码登录',
  loginTypeOther: '其他登录方式',
  changePassword: '修改密码',
  account: '账号',
  accountPlaceholder: '请输入登录账号',
  accountError: '请输入正确的登录账号',
  password: '密码',
  passwordPlaceholder: '请输入登录密码',
  passwordFormatError: '密码格式错误，请重新输入',
  protocolChecked1: '我已阅读并同意',
  protocolChecked2: '服务协议',
  protocolChecked3: '隐私协议',
  passwordFree: '7天免登录',
  mobileAndEmail: '手机号码/电子邮箱',
  mobileNo: '手机号码',
  vertifyCode: '验证码',
  mobileAndEmailPlaceholder: '请输入手机号码/电子邮箱',
  mobileAndEmailError: '请输入正确的手机号或邮箱',
  getVertifycode: '获取验证码',
  getVertifycodePlaceholder: '请输入验证码',
  vertifycodeError: '验证码输入错误，请重新输入',
  qrcodeText1: '您的微信尚未绑定iWays账号,',
  qrcodeText2: '验证码登录绑定微信',
  qrcodeText3: '后可扫码快速登录',
  qrcodeText4: '绑定账号后，可使用微信扫码登录',
  agreeUserAuth: '请勾选协议',
  newPassword: '新密码',
  newPasswordPlaceholder: '请输入新密码',
  confirmPassword: '确认密码',
  agenInputPassword: '请再次输入新密码',
  agenInputPasswordError: '两次填写的密码不一致',
  contact1: '遇到问题？',
  contact2: '联系我们',
  contact3: '客服热线',
  contact4: '电子邮箱',
  trial_application_submitted_successfully: '试用申请提交成功',
  your_trial_application_has_been_successfully_submitted: '尊敬的用户您好，您的试用申请已经成功提交，工作人员将会在近期与您联系，敬请留意。',
  vertifycodeSendSuccess: '验证码发送成功',
  loginSuccess: '登录成功',
  LoginException: '登录异常',
  Applyfortrial: '申请试用',
  Applyfortrial2: '您可以填写申请等待联系或直接联系我们',
  name: '姓名',
  namePlaceholder: '请输入您的姓名',
  company: '公司名称',
  companyPlaceholder: '请输入您的公司名称',
  Trialproduct: '试用产品(选填)',
  Nextverification: '下一步,手机验证',
  Alreadyaccount: '有账号?去登陆',
  namePlaceholderError: '请输入50位以下字符',
  nameError: '请输入正确的姓名',
  companyPlaceholderError: '请输入100位以下字符',
  companyError: '请输入正确的公司名称',
  Pleasechooseproduct: '请选择试用产品',
  selectPls: '请选择',
  Quicksearch: '快速定位产品',
  Verificationbyphone: '手机验证',
  Pleasetrial: '您可以填写申请等待联系或直接联系我们',
  mobilePlaceholder: '请输入您的手机号码',
  Emailoptional: '邮箱(选填)',
  emailPlaceholder: '请输入您的邮箱',
  Applynow: '立即申请',
  mobilePlaceholderError: '请输入正确的手机号码',
  enterLessThan: '请输入{num}位以下字符',
  emailError: '请输入正确的邮箱',
  swipingSide: '向右滑动',
  Verified: '验证通过，超过{percent}用户',
  VerificationFailed: '验证未通过，拖动滑块将悬浮图像正确合并',
  Verifiedpass: '通过',
  backTop: '返回顶部',
  Customerservicecenter: '威尔森客服中心',
  Hotline: '咨询热线',
  Email: '邮箱地址',
  WAYSProfile: '了解威尔森',
  ScantoFollowUs: '扫码关注',
  Contactus: '联系我们',
  Waysaddress: '广东省广州市海珠区新滘中路88号海珠同创汇南1街6栋101、201单元',
  ServiceProduct: '服务与产品',
  WeidianZhijian: '威电智见',
  DaaSAuto: '达示数据',
  Companystrength: '公司实力',
  ITSupport: 'IT技术支持',
  ModelingTechnique: '建模技术支持',
  AutomobileBigData: '汽车大数据',
  CustomizedService: '数据定制',
  AboutUs: '关于我们',
  PrivacyLegal: '法律条款',
  CopyrightWays: 'Copyright @ 2009-{year} 广州威尔森信息科技有限公司 All rights reserved',
  GuangdongICPFilingNo: '粤ICP备09206296号',
  GuangdongPublicSecurityNetworkFilingNo: '粤公安网备44010602007083号',
}
